import styled from 'styled-components';

export const GridWrapper = styled('div')`
    height: calc(100% - 50px);
`;
